const exitIntentKey = `exitIntentLastShown`;

const exitIntentCallback = () => {
  const quizSection = document.getElementById('quiz-section');

  const proceed = !quizSection;

  if (proceed) {
    showExitIntentPopup();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const exitIntentPopup = document.getElementById('exit-intent-popup');

  if (window.innerWidth > 650) {
    window.addEventListener('mouseout', (e) => {
      if (e.toElement == null && e.relatedTarget == null) {

        const now = Date.now();
        const last = parseInt(localStorage.getItem(exitIntentKey), 10);

        if (!last || now - last > 1 * 60 * 60 * 1000) {
          exitIntentCallback();
          localStorage.setItem(exitIntentKey, now);
        }
      }
    });
  }

  const closeButton = document.getElementById('exit-intent-close-button');

  closeButton.addEventListener('click', () => {
    hideExitIntentPopup();
  });

  exitIntentPopup.addEventListener('click', (e) => {
    if (e.target.id === 'exit-intent-popup') {
      hideExitIntentPopup();
    }
  });

  const checkCoverageButton = document.getElementById('exit-intent-check-coverage');

  checkCoverageButton.addEventListener('click', () => {
    hideExitIntentPopup();

    const quizSection = document.getElementById('quiz-section');

    if (quizSection) {
      quizSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      showQuizPopup(window.quizData);

      window.quizData.previousType = window.quizData.type;
      window.quizData.type = 'popup';

      showQuizStep1(window.quizData);
    }
  });
});

const showExitIntentPopup = () => {
  const exitIntentPopup = document.getElementById('exit-intent-popup');
  exitIntentPopup.style.display = 'flex';

  document.body.style.overflow = 'hidden';
}

const hideExitIntentPopup = () => {
  const exitIntentPopup = document.getElementById('exit-intent-popup');
  exitIntentPopup.style.display = 'none';

  document.body.style.overflow = 'auto';
}
